// extracted by mini-css-extract-plugin
export default {"container":"Legal_container__a9Kla","turnstile":"Legal_turnstile__g6H+l","title":"Legal_title__gvqhG"};